export default __webpack_public_path__ + "static/licence-VIC-back-f925b32c5d7189f5aaffd28d7267f2e7.svg";